"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleVisibilidad = void 0;
const toggleVisibilidad = (element, mostrar) => {
    if (!element || element.nodeType !== Node.ELEMENT_NODE) {
        throw new Error('No se ha proporcionado un elemento válido');
    }
    mostrar ? element.classList.remove('d-none') : element.classList.add('d-none');
};
exports.toggleVisibilidad = toggleVisibilidad;
